import { createContext } from "react";
import type { PrincipalResponse, RegisterRequest } from "@/api/types";

export interface AuthContextValue {
  principal: PrincipalResponse | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  /** Legacy fake-auth login (AUTH_MODE=fake only). */
  login: (userId: string, roles?: string[]) => Promise<void>;
  loginWithPassword: (email: string, password: string) => Promise<void>;
  register: (payload: RegisterRequest) => Promise<void>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
